export default "__VITE_ASSET__533b3887__"